// extracted by mini-css-extract-plugin
export var actions = "_mf-5";
export var assistantBubble = "_mf-3";
export var assistantRow = "_mf-6";
export var bubble = "_mf-0";
export var humanAvatar = "_mf-4";
export var inlineToolCard = "_mf-1";
export var userBubble = "_mf-2";